import { Fragment, useEffect, useRef, useState } from "react";
import TableRow from "./TableRow";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getheader, serverUrl, translateError } from "../store/api/CommonFunctions";
import Loader from "react-loader-spinner";
import { CaretLeftFill, CaretRightFill } from "react-bootstrap-icons";

export default function BihamtaTable(props) {
    const { columns, searchMethod, filterData, rowButtons, reducerName, objectName } = props;
    //apiUrl: When You Whant Fetch Data With Url Directly From Server
    //apiMethod: Get/POST
    //getData: For When You Have Method For Getting Data And Updating State
    //reducerName: Name Of Reducer Affected By Your Method
    //objectName: Object Have Been Filled By Dispatcher
    //filterData Is An JSON Object
    const webCols = columns.filter(c => !c.justInMobile && c.colName.toLowerCase() !== "rownumber");
    const mobileCols = columns.filter(c => c.justInMobile && c.colName.toLowerCase() !== "rownumber");
    const rowNumber = columns.find(c => c.colName.toLowerCase() === "rownumber");
    const currPage = useRef(1);
    const totalPage = useRef(0);
    const totalCount = useRef(-1);
    const resultList = useRef({});
    const [fetchedData, onGetData] = useState([]);
    const [searchError, setSearchError] = useState(null);

    const list = useSelector(state => state ? state[reducerName][objectName] : []);
    if (reducerName && objectName) {
        if (list.Data) {
            resultList.current = list.Data;
        }
        else {
            resultList.current = list;
        }
        if (list.TotalCount) {
            totalCount.current = Number(list.TotalCount);
        }
        else {
            totalCount.current = -1;
        }
    }
    else {
        if (fetchedData.Data) {
            resultList.current = fetchedData.Data;
        }
        else {
            resultList.current = fetchedData;
        }
        if (fetchedData.TotalCount) {
            totalCount.current = Number(fetchedData.TotalCount);
        }
        else {
            totalCount.current = -1;
        }
    }
    if (filterData?.Skip === 0 || totalPage.current < 1) {
        currPage.current = 1;
        const t = resultList.current && totalCount.current > -1 ? totalCount.current : 0;
        totalPage.current = Math.floor(t / 10) + ((t % 10) > 0 ? 1 : 0);
    }
    function changePage(inc) {
        if (inc) {
            currPage.current++;
        }
        else {
            currPage.current--;
        }
        if (filterData) {
            filterData.Skip = currPage.current - 1;
        }
        searchMethod(filterData);
    }
    return (
        <Fragment>
            <Table className="mt-2" responsive>
                <thead>
                    <tr>
                        {rowNumber && <th>{rowNumber.colTitle}</th>}
                        {mobileCols && mobileCols.map((c, i) => {return (c.showCondition === undefined || c.showCondition() === true) && <th key={i} style={{textAlign:"center"}}>{c.colTitle}</th>})}
                        {webCols && window.innerWidth > 414 &&
                            webCols.map((c, i) => {return (c.showCondition === undefined || c.showCondition() === true) &&<th key={i}  style={{textAlign:"center"}}>{c.colTitle}</th>})
                        }
                        {window.innerWidth > 414 && rowButtons && rowButtons.length > 0 && <th style={{maxWidth:"max-content", width:"max-content"}}>&nbsp;</th>}
                    </tr>
                </thead>
                <tbody>
                    {resultList.current === "PENDING" &&
                        <tr>
                            <td colSpan={columns.length + (rowNumber ? 1 : 0)} style={{ textAlign: "center" }}>
                                <Loader type="BallTriangle" color="#bb1370" height={30} />
                            </td>
                        </tr>}
                    {resultList.current !== "PENDING" && resultList.current && resultList.current &&
                        resultList.current.map((item, i) =>
                            <TableRow key={i} row={item} buttons={rowButtons} indx={i} cols={columns} />)
                    }
                </tbody>
            </Table>
            {Number(filterData?.Take) > 0 && totalCount.current > -1 &&
                <div style={{ textAlign: "center" }}>
                    <button className="btn btn-block" style={{ padding: "2px", marginRight: "2px" }} title='صفحه قبل' disabled={currPage.current === 1} onClick={() => { changePage(false) }}><CaretRightFill size={25} /></button>
                    <span>{currPage.current + " از " + totalPage.current}</span>{resultList.current?.TotalCount && <span style={{ color: "gray" }}>&nbsp;{`(${resultList.current.TotalCount})`}</span>}
                    <button className="btn btn-block" style={{ padding: "2px", marginLeft: "2px" }} title='صفحه بعد' disabled={currPage.current === totalPage.current} onClick={() => changePage(true)}><CaretLeftFill size={25} /></button>
                </div>
            }
        </Fragment>
    )
}